import { React, useState, useEffect, useCallback } from "react";
import ReactECharts from "echarts-for-react"; // or var ReactECharts = require('echarts-for-react');

// import the core library.
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from "echarts";
// Import charts, all with Chart suffix
import {
  // LineChart,
  // BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from "echarts/charts";
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from "echarts/components";
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from "echarts/renderers";
import "./echarts.scss";

const Gauge = (props) => {
  const [selectCharging, setSelectCharging] = useState(true);
  const [selectDischarging, setSelectDischarging] = useState(true);
  const [fleetCharge, setFleetCharge] = useState(true);
  const [fleetDischarge, setFleetDischarge] = useState(true);
  // Register the required components
  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    GaugeChart,
    CanvasRenderer,
  ]);

  const options = () => ({
    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: 400,
        splitNumber: 12,
        radius: "100%", // this
        center: ["50%", "65%"],
        itemStyle: {
          color: props.color,
          shadowColor: "rgba(0,138,255,0.45)",
          shadowBlur: 0,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
        },
        legend: { display: false, top: 0 },
        textStyle: {
          fontFamily: "Montserrat",
        },
        progress: {
          show: true,
          roundCap: false,
          width: 20,
        },
        axisLine: {
          roundCap: false,
          lineStyle: {
            width: 20,
          },
        },
        pointer: {
          show: false,
          icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
          length: "75%",
          width: 10,
          offsetCenter: [0, "5%"],
        },
        axisTick: {
          show: false,
          splitNumber: 2,
          lineStyle: {
            width: 2,
            color: "#999",
          },
        },
        splitLine: {
          show: false,
          length: 1000,
          lineStyle: {
            width: 3,
            color: "#999",
          },
        },
        axisLabel: {
          show: false,
          distance: 0,
          color: "#999",
          fontSize: 20,
        },
        title: {
          show: false,
        },
        detail: {
          show: true,
          backgroundColor: "#fff",
          borderColor: "#999",
          borderWidth: 0,
          width: "0%",
          lineHeight: 40,
          height: 40,
          borderRadius: 0,
          offsetCenter: [0, "20%"],
          valueAnimation: true,
          formatter: function (value) {
            if (isNaN(value)) {
              return "{value|" + 0 + "}{unit| kW}";
            } else {
              return "{value|" + value.toFixed(2) + "}{unit| kW}";
            }
          },
          rich: {
            value: {
              fontSize: 20,
              fontWeight: "600",
              color: "#000000",
              fontFamily: "Montserrat",
              padding: [25, 0, 0, 3],
            },
            unit: {
              fontSize: 20,
              color: "#000000",
              fontWeight: "600",
              fontFamily: "Montserrat",
              padding: [25, 0, 0, 0],
            },
          },
        },
        grid: {
          left: "10%",
          right: "10%",
          top: 0,
          bottom: 0,
        },
        data: [
          {
            value: props.dataVal,
          },
        ],
      },
    ],
  });
  const onCharginClick = useCallback(() => {
    setSelectCharging(!selectCharging);
    props?.chargingData(selectCharging);
  }, [selectCharging]);

  const onDischargingClick = useCallback(
    (params) => {
      setSelectDischarging(!selectDischarging);
      props?.dischargingData(selectDischarging);
    },
    [selectDischarging]
  );

  const onFleetCharge = useCallback(
    (params) => {
      setFleetCharge(!fleetCharge);
      props?.chargingFleet(fleetCharge);
    },
    [fleetCharge]
  );

  const onFleetDischarge = useCallback(
    (params) => {
      setFleetDischarge(!fleetDischarge);
      props?.dischargingFleet(fleetDischarge);
    },
    [fleetDischarge]
  );

  const chargingEvent = {
    click: onCharginClick,
  };

  const dischargingEvent = {
    click: onDischargingClick,
  };

  const fleetChargeEvent = {
    click: onFleetCharge,
  };

  const fleetDischargeEvent = {
    click: onFleetDischarge,
  };

  return (
    <div
      className="gauge_container"
      onClick={
        props?.name === "charging"
          ? onCharginClick
          : props?.name === "discharging"
          ? onDischargingClick
          : props?.name === "fleetCharging"
          ? onFleetCharge
          : props?.name === "fleetDischarging"
          ? onFleetDischarge
          : ""
      }
    >
      <ReactECharts
        echarts={echarts}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        name="gaugeChart"
        //onChartReady={this.onChartReadyCallback}
        //onEvents={EventsDict}
        style={{ height: "90%", width: "100%" }}
        opts={{ renderer: "svg" }} // use svg to render the chart.
        option={options()}
        //disabling click for 13june
        // onEvents={chargingEvent}
        onEvents={
          props?.name === "charging"
            ? chargingEvent
            : props?.name === "discharging"
            ? dischargingEvent
            : props?.name === "fleetCharging"
            ? fleetChargeEvent
            : props?.name === "fleetDischarging"
            ? fleetDischargeEvent
            : ""
        }

        // onEvents = {(e)=> chargingEvent(e)}
      />
    </div>
  );
};

export default Gauge;
